/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnticipatoryTenantUser,
  AnticipatoryTenantUserError,
  AnticipatoryTenantUserRequest,
  Controller,
  CurrentUser,
  DeviceOrdering,
  License,
  LicenseCreation,
  LicenseCreationError,
  LicenseCreationRequest,
  LicenseError,
  LicenseOrdering,
  LicenseUpdate,
  LicenseUpdateError,
  LicenseUpdateRequest,
  LicensedStatus,
  MinimalTenant,
  PaginatedDeviceList,
  PaginatedLicenseList,
  PaginatedPolicyList,
  PaginatedSeatList,
  PaginatedTenantListList,
  PaginatedTenantSearchList,
  PatchedTenantDetailRequest,
  PatchedTenantUserRequest,
  Policy,
  PolicyError,
  PolicyOrdering,
  PolicyRequest,
  ProductType,
  ProvisionalLicenseCreation,
  ProvisionalLicenseCreationError,
  ProvisionalLicenseCreationRequest,
  Region,
  Seat,
  SeatError,
  SeatOrdering,
  TenantAffiliate,
  TenantAffiliateError,
  TenantAffiliateRequest,
  TenantCreation,
  TenantCreationError,
  TenantCreationRequest,
  TenantDetail,
  TenantDetailError,
  TenantDetailRequest,
  TenantOrdering,
  TenantRenewals,
  TenantSearchOrdering,
  TenantType,
  TenantUser,
  TenantUserError,
  TenantUserRequest,
} from '../models';
import {
    AnticipatoryTenantUserFromJSON,
    AnticipatoryTenantUserToJSON,
    AnticipatoryTenantUserErrorFromJSON,
    AnticipatoryTenantUserErrorToJSON,
    AnticipatoryTenantUserRequestFromJSON,
    AnticipatoryTenantUserRequestToJSON,
    ControllerFromJSON,
    ControllerToJSON,
    CurrentUserFromJSON,
    CurrentUserToJSON,
    DeviceOrderingFromJSON,
    DeviceOrderingToJSON,
    LicenseFromJSON,
    LicenseToJSON,
    LicenseCreationFromJSON,
    LicenseCreationToJSON,
    LicenseCreationErrorFromJSON,
    LicenseCreationErrorToJSON,
    LicenseCreationRequestFromJSON,
    LicenseCreationRequestToJSON,
    LicenseErrorFromJSON,
    LicenseErrorToJSON,
    LicenseOrderingFromJSON,
    LicenseOrderingToJSON,
    LicenseUpdateFromJSON,
    LicenseUpdateToJSON,
    LicenseUpdateErrorFromJSON,
    LicenseUpdateErrorToJSON,
    LicenseUpdateRequestFromJSON,
    LicenseUpdateRequestToJSON,
    LicensedStatusFromJSON,
    LicensedStatusToJSON,
    MinimalTenantFromJSON,
    MinimalTenantToJSON,
    PaginatedDeviceListFromJSON,
    PaginatedDeviceListToJSON,
    PaginatedLicenseListFromJSON,
    PaginatedLicenseListToJSON,
    PaginatedPolicyListFromJSON,
    PaginatedPolicyListToJSON,
    PaginatedSeatListFromJSON,
    PaginatedSeatListToJSON,
    PaginatedTenantListListFromJSON,
    PaginatedTenantListListToJSON,
    PaginatedTenantSearchListFromJSON,
    PaginatedTenantSearchListToJSON,
    PatchedTenantDetailRequestFromJSON,
    PatchedTenantDetailRequestToJSON,
    PatchedTenantUserRequestFromJSON,
    PatchedTenantUserRequestToJSON,
    PolicyFromJSON,
    PolicyToJSON,
    PolicyErrorFromJSON,
    PolicyErrorToJSON,
    PolicyOrderingFromJSON,
    PolicyOrderingToJSON,
    PolicyRequestFromJSON,
    PolicyRequestToJSON,
    ProductTypeFromJSON,
    ProductTypeToJSON,
    ProvisionalLicenseCreationFromJSON,
    ProvisionalLicenseCreationToJSON,
    ProvisionalLicenseCreationErrorFromJSON,
    ProvisionalLicenseCreationErrorToJSON,
    ProvisionalLicenseCreationRequestFromJSON,
    ProvisionalLicenseCreationRequestToJSON,
    RegionFromJSON,
    RegionToJSON,
    SeatFromJSON,
    SeatToJSON,
    SeatErrorFromJSON,
    SeatErrorToJSON,
    SeatOrderingFromJSON,
    SeatOrderingToJSON,
    TenantAffiliateFromJSON,
    TenantAffiliateToJSON,
    TenantAffiliateErrorFromJSON,
    TenantAffiliateErrorToJSON,
    TenantAffiliateRequestFromJSON,
    TenantAffiliateRequestToJSON,
    TenantCreationFromJSON,
    TenantCreationToJSON,
    TenantCreationErrorFromJSON,
    TenantCreationErrorToJSON,
    TenantCreationRequestFromJSON,
    TenantCreationRequestToJSON,
    TenantDetailFromJSON,
    TenantDetailToJSON,
    TenantDetailErrorFromJSON,
    TenantDetailErrorToJSON,
    TenantDetailRequestFromJSON,
    TenantDetailRequestToJSON,
    TenantOrderingFromJSON,
    TenantOrderingToJSON,
    TenantRenewalsFromJSON,
    TenantRenewalsToJSON,
    TenantSearchOrderingFromJSON,
    TenantSearchOrderingToJSON,
    TenantTypeFromJSON,
    TenantTypeToJSON,
    TenantUserFromJSON,
    TenantUserToJSON,
    TenantUserErrorFromJSON,
    TenantUserErrorToJSON,
    TenantUserRequestFromJSON,
    TenantUserRequestToJSON,
} from '../models';

export interface TenantAffiliateCreateRequest {
    id: string;
    tenantAffiliateRequest: TenantAffiliateRequest;
}

export interface TenantBlockedDeviceListRequest {
    tenantId: string;
    name?: string;
    ordering?: DeviceOrdering | `-${DeviceOrdering}`;
    page?: number;
    pageSize?: number;
    userFacingId?: string;
}

export interface TenantBlockedDeviceUnblockDestroyRequest {
    fingerprint: string;
    tenantId: string;
}

export interface TenantControllerRetrieveRequest {
    id: string;
}

export interface TenantCreateRequest {
    tenantCreationRequest: TenantCreationRequest;
}

export interface TenantLicenseCreateRequest {
    tenantId: string;
    licenseCreationRequest: LicenseCreationRequest;
}

export interface TenantLicenseListRequest {
    tenantId: string;
    activationDateAfter?: Date;
    activationDateBefore?: Date;
    autoRenew?: boolean;
    edition?: string;
    expiryDateAfter?: Date;
    expiryDateBefore?: Date;
    isSubscription?: boolean;
    licenseNumber?: string;
    ordering?: LicenseOrdering | `-${LicenseOrdering}`;
    page?: number;
    pageSize?: number;
    product?: Array<string>;
    productSku?: Array<string>;
    productType?: ProductType;
}

export interface TenantLicensePartialUpdateRequest {
    id: string;
    tenantId: string;
}

export interface TenantLicenseRetrieveRequest {
    id: string;
    tenantId: string;
}

export interface TenantLicenseUpdateRequest {
    id: string;
    tenantId: string;
    licenseUpdateRequest: LicenseUpdateRequest;
}

export interface TenantListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    edition?: string;
    editions?: Array<string>;
    email?: string;
    fullManageability?: boolean;
    ordering?: TenantOrdering | `-${TenantOrdering}`;
    page?: number;
    pageSize?: number;
    partner?: string;
    productType?: ProductType;
    products?: Array<string>;
    region?: Region;
    tenant?: string;
    tenantType?: TenantType;
}

export interface TenantLookupRetrieveRequest {
    lookup: string;
}

export interface TenantPartialUpdateRequest {
    id: string;
    patchedTenantDetailRequest?: PatchedTenantDetailRequest;
}

export interface TenantPolicyCreateRequest {
    tenantId: string;
    policyRequest: PolicyRequest;
}

export interface TenantPolicyLatestRetrieveRequest {
    tenantId: string;
    ordering?: PolicyOrdering | `-${PolicyOrdering}`;
}

export interface TenantPolicyListRequest {
    tenantId: string;
    ordering?: PolicyOrdering | `-${PolicyOrdering}`;
    page?: number;
    pageSize?: number;
}

export interface TenantPolicyRetrieveRequest {
    id: string;
    tenantId: string;
}

export interface TenantProvisionalLicenseCreateRequest {
    tenantId: string;
    provisionalLicenseCreationRequest: ProvisionalLicenseCreationRequest;
}

export interface TenantRenewalsRetrieveRequest {
    id: string;
}

export interface TenantRetrieveRequest {
    id: string;
}

export interface TenantSearchListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    email?: string;
    fullManageability?: boolean;
    ordering?: TenantSearchOrdering | `-${TenantSearchOrdering}`;
    page?: number;
    pageSize?: number;
    partner?: string;
    productType?: ProductType;
    products?: Array<string>;
    tenant?: string;
}

export interface TenantSeatAllocateCreateRequest {
    fingerprint: string;
    tenantId: string;
}

export interface TenantSeatBlockDestroyRequest {
    fingerprint: string;
    tenantId: string;
}

export interface TenantSeatDeallocateCreateRequest {
    fingerprint: string;
    tenantId: string;
}

export interface TenantSeatDissociateDestroyRequest {
    fingerprint: string;
    tenantId: string;
}

export interface TenantSeatListRequest {
    tenantId: string;
    directLicensedEditions?: string;
    firstSeenAfter?: Date;
    firstSeenBefore?: Date;
    licenseNumbers?: string;
    licensedEditions?: string;
    licensedStatus?: LicensedStatus;
    name?: string;
    ordering?: SeatOrdering | `-${SeatOrdering}`;
    page?: number;
    pageSize?: number;
    serial?: string;
    unlicensedEditions?: string;
    userFacingId?: string;
}

export interface TenantSeatRequestCheckinCreateRequest {
    fingerprint: string;
    tenantId: string;
}

export interface TenantSeatRetrieveRequest {
    fingerprint: string;
    tenantId: string;
}

export interface TenantUpdateRequest {
    id: string;
    tenantDetailRequest: TenantDetailRequest;
}

export interface TenantUpgradeCreateRequest {
    id: string;
}

export interface TenantUserCreateRequest {
    tenantId: string;
    anticipatoryTenantUserRequest: AnticipatoryTenantUserRequest;
}

export interface TenantUserCurrentRetrieveRequest {
    tenantId: string;
}

export interface TenantUserDestroyRequest {
    id: string;
    tenantId: string;
}

export interface TenantUserListRequest {
    tenantId: string;
}

export interface TenantUserPartialUpdateRequest {
    id: string;
    tenantId: string;
    patchedTenantUserRequest?: PatchedTenantUserRequest;
}

export interface TenantUserRetrieveRequest {
    id: string;
    tenantId: string;
}

export interface TenantUserUpdateRequest {
    id: string;
    tenantId: string;
    tenantUserRequest: TenantUserRequest;
}

/**
 * 
 */
export class TenantApi extends runtime.BaseAPI {

    /**
     * Affiliate a WPSE device to an existing customer tenant at the end of ActivationWorkflow.DEVICE
     */
    async tenantAffiliateCreateRaw(requestParameters: TenantAffiliateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantAffiliate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantAffiliateCreate.');
        }

        if (requestParameters.tenantAffiliateRequest === null || requestParameters.tenantAffiliateRequest === undefined) {
            throw new runtime.RequiredError('tenantAffiliateRequest','Required parameter requestParameters.tenantAffiliateRequest was null or undefined when calling tenantAffiliateCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{id}/affiliate/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TenantAffiliateRequestToJSON(requestParameters.tenantAffiliateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantAffiliateFromJSON(jsonValue));
    }

    /**
     * Affiliate a WPSE device to an existing customer tenant at the end of ActivationWorkflow.DEVICE
     */
    async tenantAffiliateCreate(requestParameters: TenantAffiliateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantAffiliate> {
        const response = await this.tenantAffiliateCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantBlockedDeviceListRaw(requestParameters: TenantBlockedDeviceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDeviceList>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantBlockedDeviceList.');
        }

        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.userFacingId !== undefined) {
            queryParameters['user_facing_id'] = requestParameters.userFacingId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/blocked-device/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDeviceListFromJSON(jsonValue));
    }

    /**
     */
    async tenantBlockedDeviceList(requestParameters: TenantBlockedDeviceListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDeviceList> {
        const response = await this.tenantBlockedDeviceListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantBlockedDeviceUnblockDestroyRaw(requestParameters: TenantBlockedDeviceUnblockDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.fingerprint === null || requestParameters.fingerprint === undefined) {
            throw new runtime.RequiredError('fingerprint','Required parameter requestParameters.fingerprint was null or undefined when calling tenantBlockedDeviceUnblockDestroy.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantBlockedDeviceUnblockDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/blocked-device/{fingerprint}/unblock/`.replace(`{${"fingerprint"}}`, encodeURIComponent(String(requestParameters.fingerprint))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async tenantBlockedDeviceUnblockDestroy(requestParameters: TenantBlockedDeviceUnblockDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.tenantBlockedDeviceUnblockDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async tenantControllerRetrieveRaw(requestParameters: TenantControllerRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Controller>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantControllerRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{id}/controller/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControllerFromJSON(jsonValue));
    }

    /**
     */
    async tenantControllerRetrieve(requestParameters: TenantControllerRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Controller> {
        const response = await this.tenantControllerRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantCreateRaw(requestParameters: TenantCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantCreation>> {
        if (requestParameters.tenantCreationRequest === null || requestParameters.tenantCreationRequest === undefined) {
            throw new runtime.RequiredError('tenantCreationRequest','Required parameter requestParameters.tenantCreationRequest was null or undefined when calling tenantCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TenantCreationRequestToJSON(requestParameters.tenantCreationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantCreationFromJSON(jsonValue));
    }

    /**
     */
    async tenantCreate(requestParameters: TenantCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantCreation> {
        const response = await this.tenantCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantLicenseCreateRaw(requestParameters: TenantLicenseCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseCreation>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantLicenseCreate.');
        }

        if (requestParameters.licenseCreationRequest === null || requestParameters.licenseCreationRequest === undefined) {
            throw new runtime.RequiredError('licenseCreationRequest','Required parameter requestParameters.licenseCreationRequest was null or undefined when calling tenantLicenseCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/license/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LicenseCreationRequestToJSON(requestParameters.licenseCreationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseCreationFromJSON(jsonValue));
    }

    /**
     */
    async tenantLicenseCreate(requestParameters: TenantLicenseCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseCreation> {
        const response = await this.tenantLicenseCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantLicenseListRaw(requestParameters: TenantLicenseListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedLicenseList>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantLicenseList.');
        }

        const queryParameters: any = {};

        if (requestParameters.activationDateAfter !== undefined) {
            queryParameters['activation_date_after'] = (requestParameters.activationDateAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.activationDateBefore !== undefined) {
            queryParameters['activation_date_before'] = (requestParameters.activationDateBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.autoRenew !== undefined) {
            queryParameters['auto_renew'] = requestParameters.autoRenew;
        }

        if (requestParameters.edition !== undefined) {
            queryParameters['edition'] = requestParameters.edition;
        }

        if (requestParameters.expiryDateAfter !== undefined) {
            queryParameters['expiry_date_after'] = (requestParameters.expiryDateAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.expiryDateBefore !== undefined) {
            queryParameters['expiry_date_before'] = (requestParameters.expiryDateBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.isSubscription !== undefined) {
            queryParameters['is_subscription'] = requestParameters.isSubscription;
        }

        if (requestParameters.licenseNumber !== undefined) {
            queryParameters['license_number'] = requestParameters.licenseNumber;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.product) {
            queryParameters['product'] = requestParameters.product;
        }

        if (requestParameters.productSku) {
            queryParameters['product_sku'] = requestParameters.productSku;
        }

        if (requestParameters.productType !== undefined) {
            queryParameters['product_type'] = requestParameters.productType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/license/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedLicenseListFromJSON(jsonValue));
    }

    /**
     */
    async tenantLicenseList(requestParameters: TenantLicenseListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedLicenseList> {
        const response = await this.tenantLicenseListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantLicensePartialUpdateRaw(requestParameters: TenantLicensePartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<License>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantLicensePartialUpdate.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantLicensePartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/license/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseFromJSON(jsonValue));
    }

    /**
     */
    async tenantLicensePartialUpdate(requestParameters: TenantLicensePartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<License> {
        const response = await this.tenantLicensePartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantLicenseRetrieveRaw(requestParameters: TenantLicenseRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<License>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantLicenseRetrieve.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantLicenseRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/license/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseFromJSON(jsonValue));
    }

    /**
     */
    async tenantLicenseRetrieve(requestParameters: TenantLicenseRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<License> {
        const response = await this.tenantLicenseRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantLicenseUpdateRaw(requestParameters: TenantLicenseUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseUpdate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantLicenseUpdate.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantLicenseUpdate.');
        }

        if (requestParameters.licenseUpdateRequest === null || requestParameters.licenseUpdateRequest === undefined) {
            throw new runtime.RequiredError('licenseUpdateRequest','Required parameter requestParameters.licenseUpdateRequest was null or undefined when calling tenantLicenseUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/license/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LicenseUpdateRequestToJSON(requestParameters.licenseUpdateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseUpdateFromJSON(jsonValue));
    }

    /**
     */
    async tenantLicenseUpdate(requestParameters: TenantLicenseUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseUpdate> {
        const response = await this.tenantLicenseUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantListRaw(requestParameters: TenantListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTenantListList>> {
        const queryParameters: any = {};

        if (requestParameters.createdAtAfter !== undefined) {
            queryParameters['created_at_after'] = (requestParameters.createdAtAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.createdAtBefore !== undefined) {
            queryParameters['created_at_before'] = (requestParameters.createdAtBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.edition !== undefined) {
            queryParameters['edition'] = requestParameters.edition;
        }

        if (requestParameters.editions) {
            queryParameters['editions'] = requestParameters.editions;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.fullManageability !== undefined) {
            queryParameters['full_manageability'] = requestParameters.fullManageability;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.partner !== undefined) {
            queryParameters['partner'] = requestParameters.partner;
        }

        if (requestParameters.productType !== undefined) {
            queryParameters['product_type'] = requestParameters.productType;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.region !== undefined) {
            queryParameters['region'] = requestParameters.region;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTenantListListFromJSON(jsonValue));
    }

    /**
     */
    async tenantList(requestParameters: TenantListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTenantListList> {
        const response = await this.tenantListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantLookupRetrieveRaw(requestParameters: TenantLookupRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MinimalTenant>> {
        if (requestParameters.lookup === null || requestParameters.lookup === undefined) {
            throw new runtime.RequiredError('lookup','Required parameter requestParameters.lookup was null or undefined when calling tenantLookupRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/lookup/{lookup}/`.replace(`{${"lookup"}}`, encodeURIComponent(String(requestParameters.lookup))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MinimalTenantFromJSON(jsonValue));
    }

    /**
     */
    async tenantLookupRetrieve(requestParameters: TenantLookupRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MinimalTenant> {
        const response = await this.tenantLookupRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantPartialUpdateRaw(requestParameters: TenantPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDetail>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantPartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedTenantDetailRequestToJSON(requestParameters.patchedTenantDetailRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantDetailFromJSON(jsonValue));
    }

    /**
     */
    async tenantPartialUpdate(requestParameters: TenantPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDetail> {
        const response = await this.tenantPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantPolicyCreateRaw(requestParameters: TenantPolicyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Policy>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantPolicyCreate.');
        }

        if (requestParameters.policyRequest === null || requestParameters.policyRequest === undefined) {
            throw new runtime.RequiredError('policyRequest','Required parameter requestParameters.policyRequest was null or undefined when calling tenantPolicyCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/policy/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PolicyRequestToJSON(requestParameters.policyRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PolicyFromJSON(jsonValue));
    }

    /**
     */
    async tenantPolicyCreate(requestParameters: TenantPolicyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Policy> {
        const response = await this.tenantPolicyCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantPolicyLatestRetrieveRaw(requestParameters: TenantPolicyLatestRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Policy>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantPolicyLatestRetrieve.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/policy/latest/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PolicyFromJSON(jsonValue));
    }

    /**
     */
    async tenantPolicyLatestRetrieve(requestParameters: TenantPolicyLatestRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Policy> {
        const response = await this.tenantPolicyLatestRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantPolicyListRaw(requestParameters: TenantPolicyListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPolicyList>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantPolicyList.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/policy/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPolicyListFromJSON(jsonValue));
    }

    /**
     */
    async tenantPolicyList(requestParameters: TenantPolicyListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPolicyList> {
        const response = await this.tenantPolicyListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantPolicyRetrieveRaw(requestParameters: TenantPolicyRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Policy>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantPolicyRetrieve.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantPolicyRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/policy/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PolicyFromJSON(jsonValue));
    }

    /**
     */
    async tenantPolicyRetrieve(requestParameters: TenantPolicyRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Policy> {
        const response = await this.tenantPolicyRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Use this ViewSet as a base for ViewSets that will be nested directly beneath the TenantViewSet above.
     */
    async tenantProvisionalLicenseCreateRaw(requestParameters: TenantProvisionalLicenseCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProvisionalLicenseCreation>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantProvisionalLicenseCreate.');
        }

        if (requestParameters.provisionalLicenseCreationRequest === null || requestParameters.provisionalLicenseCreationRequest === undefined) {
            throw new runtime.RequiredError('provisionalLicenseCreationRequest','Required parameter requestParameters.provisionalLicenseCreationRequest was null or undefined when calling tenantProvisionalLicenseCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/provisional-license/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProvisionalLicenseCreationRequestToJSON(requestParameters.provisionalLicenseCreationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProvisionalLicenseCreationFromJSON(jsonValue));
    }

    /**
     * Use this ViewSet as a base for ViewSets that will be nested directly beneath the TenantViewSet above.
     */
    async tenantProvisionalLicenseCreate(requestParameters: TenantProvisionalLicenseCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProvisionalLicenseCreation> {
        const response = await this.tenantProvisionalLicenseCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantRenewalsRetrieveRaw(requestParameters: TenantRenewalsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRenewals>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantRenewalsRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{id}/renewals/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantRenewalsFromJSON(jsonValue));
    }

    /**
     */
    async tenantRenewalsRetrieve(requestParameters: TenantRenewalsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRenewals> {
        const response = await this.tenantRenewalsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantRetrieveRaw(requestParameters: TenantRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDetail>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantDetailFromJSON(jsonValue));
    }

    /**
     */
    async tenantRetrieve(requestParameters: TenantRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDetail> {
        const response = await this.tenantRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantSearchListRaw(requestParameters: TenantSearchListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTenantSearchList>> {
        const queryParameters: any = {};

        if (requestParameters.createdAtAfter !== undefined) {
            queryParameters['created_at_after'] = (requestParameters.createdAtAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.createdAtBefore !== undefined) {
            queryParameters['created_at_before'] = (requestParameters.createdAtBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.fullManageability !== undefined) {
            queryParameters['full_manageability'] = requestParameters.fullManageability;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.partner !== undefined) {
            queryParameters['partner'] = requestParameters.partner;
        }

        if (requestParameters.productType !== undefined) {
            queryParameters['product_type'] = requestParameters.productType;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/search/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTenantSearchListFromJSON(jsonValue));
    }

    /**
     */
    async tenantSearchList(requestParameters: TenantSearchListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTenantSearchList> {
        const response = await this.tenantSearchListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Try to allocate a license to this seat, if there is capacity
     */
    async tenantSeatAllocateCreateRaw(requestParameters: TenantSeatAllocateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Seat>> {
        if (requestParameters.fingerprint === null || requestParameters.fingerprint === undefined) {
            throw new runtime.RequiredError('fingerprint','Required parameter requestParameters.fingerprint was null or undefined when calling tenantSeatAllocateCreate.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantSeatAllocateCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/seat/{fingerprint}/allocate/`.replace(`{${"fingerprint"}}`, encodeURIComponent(String(requestParameters.fingerprint))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeatFromJSON(jsonValue));
    }

    /**
     * Try to allocate a license to this seat, if there is capacity
     */
    async tenantSeatAllocateCreate(requestParameters: TenantSeatAllocateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Seat> {
        const response = await this.tenantSeatAllocateCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove the association between the device and the tenant (and licenses) and block device to stop re-association
     */
    async tenantSeatBlockDestroyRaw(requestParameters: TenantSeatBlockDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.fingerprint === null || requestParameters.fingerprint === undefined) {
            throw new runtime.RequiredError('fingerprint','Required parameter requestParameters.fingerprint was null or undefined when calling tenantSeatBlockDestroy.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantSeatBlockDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/seat/{fingerprint}/block/`.replace(`{${"fingerprint"}}`, encodeURIComponent(String(requestParameters.fingerprint))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove the association between the device and the tenant (and licenses) and block device to stop re-association
     */
    async tenantSeatBlockDestroy(requestParameters: TenantSeatBlockDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.tenantSeatBlockDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Deallocate any license attached to this seat, though retain the device\'s association with the tenant
     */
    async tenantSeatDeallocateCreateRaw(requestParameters: TenantSeatDeallocateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Seat>> {
        if (requestParameters.fingerprint === null || requestParameters.fingerprint === undefined) {
            throw new runtime.RequiredError('fingerprint','Required parameter requestParameters.fingerprint was null or undefined when calling tenantSeatDeallocateCreate.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantSeatDeallocateCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/seat/{fingerprint}/deallocate/`.replace(`{${"fingerprint"}}`, encodeURIComponent(String(requestParameters.fingerprint))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeatFromJSON(jsonValue));
    }

    /**
     * Deallocate any license attached to this seat, though retain the device\'s association with the tenant
     */
    async tenantSeatDeallocateCreate(requestParameters: TenantSeatDeallocateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Seat> {
        const response = await this.tenantSeatDeallocateCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove the association between the device and the tenant as well as any license allocation it may have had
     */
    async tenantSeatDissociateDestroyRaw(requestParameters: TenantSeatDissociateDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.fingerprint === null || requestParameters.fingerprint === undefined) {
            throw new runtime.RequiredError('fingerprint','Required parameter requestParameters.fingerprint was null or undefined when calling tenantSeatDissociateDestroy.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantSeatDissociateDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/seat/{fingerprint}/dissociate/`.replace(`{${"fingerprint"}}`, encodeURIComponent(String(requestParameters.fingerprint))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove the association between the device and the tenant as well as any license allocation it may have had
     */
    async tenantSeatDissociateDestroy(requestParameters: TenantSeatDissociateDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.tenantSeatDissociateDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async tenantSeatListRaw(requestParameters: TenantSeatListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSeatList>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantSeatList.');
        }

        const queryParameters: any = {};

        if (requestParameters.directLicensedEditions !== undefined) {
            queryParameters['direct_licensed_editions'] = requestParameters.directLicensedEditions;
        }

        if (requestParameters.firstSeenAfter !== undefined) {
            queryParameters['first_seen_after'] = (requestParameters.firstSeenAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.firstSeenBefore !== undefined) {
            queryParameters['first_seen_before'] = (requestParameters.firstSeenBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.licenseNumbers !== undefined) {
            queryParameters['license_numbers'] = requestParameters.licenseNumbers;
        }

        if (requestParameters.licensedEditions !== undefined) {
            queryParameters['licensed_editions'] = requestParameters.licensedEditions;
        }

        if (requestParameters.licensedStatus !== undefined) {
            queryParameters['licensed_status'] = requestParameters.licensedStatus;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.serial !== undefined) {
            queryParameters['serial'] = requestParameters.serial;
        }

        if (requestParameters.unlicensedEditions !== undefined) {
            queryParameters['unlicensed_editions'] = requestParameters.unlicensedEditions;
        }

        if (requestParameters.userFacingId !== undefined) {
            queryParameters['user_facing_id'] = requestParameters.userFacingId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/seat/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSeatListFromJSON(jsonValue));
    }

    /**
     */
    async tenantSeatList(requestParameters: TenantSeatListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSeatList> {
        const response = await this.tenantSeatListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantSeatRequestCheckinCreateRaw(requestParameters: TenantSeatRequestCheckinCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Seat>> {
        if (requestParameters.fingerprint === null || requestParameters.fingerprint === undefined) {
            throw new runtime.RequiredError('fingerprint','Required parameter requestParameters.fingerprint was null or undefined when calling tenantSeatRequestCheckinCreate.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantSeatRequestCheckinCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/seat/{fingerprint}/request-checkin/`.replace(`{${"fingerprint"}}`, encodeURIComponent(String(requestParameters.fingerprint))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeatFromJSON(jsonValue));
    }

    /**
     */
    async tenantSeatRequestCheckinCreate(requestParameters: TenantSeatRequestCheckinCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Seat> {
        const response = await this.tenantSeatRequestCheckinCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantSeatRetrieveRaw(requestParameters: TenantSeatRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Seat>> {
        if (requestParameters.fingerprint === null || requestParameters.fingerprint === undefined) {
            throw new runtime.RequiredError('fingerprint','Required parameter requestParameters.fingerprint was null or undefined when calling tenantSeatRetrieve.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantSeatRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/seat/{fingerprint}/`.replace(`{${"fingerprint"}}`, encodeURIComponent(String(requestParameters.fingerprint))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeatFromJSON(jsonValue));
    }

    /**
     */
    async tenantSeatRetrieve(requestParameters: TenantSeatRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Seat> {
        const response = await this.tenantSeatRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantUpdateRaw(requestParameters: TenantUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDetail>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantUpdate.');
        }

        if (requestParameters.tenantDetailRequest === null || requestParameters.tenantDetailRequest === undefined) {
            throw new runtime.RequiredError('tenantDetailRequest','Required parameter requestParameters.tenantDetailRequest was null or undefined when calling tenantUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TenantDetailRequestToJSON(requestParameters.tenantDetailRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantDetailFromJSON(jsonValue));
    }

    /**
     */
    async tenantUpdate(requestParameters: TenantUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDetail> {
        const response = await this.tenantUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantUpgradeCreateRaw(requestParameters: TenantUpgradeCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDetail>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantUpgradeCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{id}/upgrade/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantDetailFromJSON(jsonValue));
    }

    /**
     */
    async tenantUpgradeCreate(requestParameters: TenantUpgradeCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDetail> {
        const response = await this.tenantUpgradeCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantUserCreateRaw(requestParameters: TenantUserCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnticipatoryTenantUser>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantUserCreate.');
        }

        if (requestParameters.anticipatoryTenantUserRequest === null || requestParameters.anticipatoryTenantUserRequest === undefined) {
            throw new runtime.RequiredError('anticipatoryTenantUserRequest','Required parameter requestParameters.anticipatoryTenantUserRequest was null or undefined when calling tenantUserCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/user/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnticipatoryTenantUserRequestToJSON(requestParameters.anticipatoryTenantUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnticipatoryTenantUserFromJSON(jsonValue));
    }

    /**
     */
    async tenantUserCreate(requestParameters: TenantUserCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnticipatoryTenantUser> {
        const response = await this.tenantUserCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantUserCurrentRetrieveRaw(requestParameters: TenantUserCurrentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentUser>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantUserCurrentRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/user/current/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrentUserFromJSON(jsonValue));
    }

    /**
     */
    async tenantUserCurrentRetrieve(requestParameters: TenantUserCurrentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CurrentUser> {
        const response = await this.tenantUserCurrentRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantUserDestroyRaw(requestParameters: TenantUserDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantUserDestroy.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantUserDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/user/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async tenantUserDestroy(requestParameters: TenantUserDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.tenantUserDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async tenantUserListRaw(requestParameters: TenantUserListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TenantUser>>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantUserList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/user/`.replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TenantUserFromJSON));
    }

    /**
     */
    async tenantUserList(requestParameters: TenantUserListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TenantUser>> {
        const response = await this.tenantUserListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantUserPartialUpdateRaw(requestParameters: TenantUserPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantUser>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantUserPartialUpdate.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantUserPartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/user/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedTenantUserRequestToJSON(requestParameters.patchedTenantUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantUserFromJSON(jsonValue));
    }

    /**
     */
    async tenantUserPartialUpdate(requestParameters: TenantUserPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantUser> {
        const response = await this.tenantUserPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantUserRetrieveRaw(requestParameters: TenantUserRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantUser>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantUserRetrieve.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantUserRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/user/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantUserFromJSON(jsonValue));
    }

    /**
     */
    async tenantUserRetrieve(requestParameters: TenantUserRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantUser> {
        const response = await this.tenantUserRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async tenantUserUpdateRaw(requestParameters: TenantUserUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantUser>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling tenantUserUpdate.');
        }

        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling tenantUserUpdate.');
        }

        if (requestParameters.tenantUserRequest === null || requestParameters.tenantUserRequest === undefined) {
            throw new runtime.RequiredError('tenantUserRequest','Required parameter requestParameters.tenantUserRequest was null or undefined when calling tenantUserUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/tenant/{tenant_id}/user/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"tenant_id"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TenantUserRequestToJSON(requestParameters.tenantUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantUserFromJSON(jsonValue));
    }

    /**
     */
    async tenantUserUpdate(requestParameters: TenantUserUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantUser> {
        const response = await this.tenantUserUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
